import { gql } from '@apollo/client';

export const ALL_HIERARCHIES = gql`
  query AllHierarchies($input: AllHierarchiesInput!) {
    hierarchies: allHierarchies(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          description
          levelsCount
        }
      }
    }
  }
`;
